import React, { useEffect, useState } from 'react';
import Page from './page';
import moment from 'moment';
import { connect } from 'react-redux';
import VimeosActions from '../../redux/actions/Vimeo';
import { withRouter } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import TooltipButton from '../../hooks/useTooltipButton';

const Vimeo = ({ vimeo, getVimeos, getVimeo, setVimeo, setUpdate, setRemove, setClearVimeo, setUpdateCover }) => {

    const initForm = { vimeoId: "", title: "", thumbnail: "" },
        [show, setShow] = useState({ add: false, edit: false }),
        [rows, setRows] = useState(null),
        [file, setFile] = useState(""),
        [pid, setPid] = useState(null),
        [form, setForm] = useState(initForm),
        [errors, setErrors] = useState({}),
        [video, setVideo] = useState({ view: false, code: "" })

    useEffect(() => {
        getVimeos()
    }, []);
    
    useEffect(() => {
        setRows(vimeo.list)
    }, [vimeo.list])

    useEffect(() => {
        if (vimeo.selected) {
            setForm({
                title: vimeo.selected.title
            })
            setShow({ ...show, edit: true })
        }
    }, [vimeo.selected]);

    useEffect(() => {
        if (!show.add && !show.edit) {
            setClearVimeo()
            setForm({ name: "", active: 1 })
        }
    }, [show.edit, show.add]);

    const

        /**
         * Handled add new position
         */
        handledAdd = () => {
            if (handleValidate()) {
                setVimeo(form)
                setShow({ ...show, add: false })
            }
        },

        /**
         * Handled update position by pid
         */
        handledUpdate = () => {
            if (handleValidate('edit')) {
                setUpdate(pid, form)
                setShow({ ...show, edit: false })
            }
        },

        /**
         * Handled update cover
         */
        handledUpdateCover = async (e) => {
            const image = e.target.files[0]
            const imageUrl = URL.createObjectURL(image);
            setFile(imageUrl)
            setUpdateCover(pid, image).then((resp) => {
                setRows(rows.map((r) => ({
                    ...r,
                    thumbnail: (pid === r.vimeo_id) ? resp?.filename : r.thumbnail
                })))
            })
        },

        /**
         * Handled show edit
         */
        handledShowEdit = (pid) => {
            setPid(pid)
            getVimeo(pid)
        },

        /**
         * Handled view video
         */
        handledShowView = (code) => {
            setVideo({ view: true, code })
        },

        /**
         * Handled show picture
         */
        handledShowCover = (row) => {
            setPid(row.vimeo_id)
            const preview = (row.thumbnail) ? `${process.env.REACT_APP_URL}vimeo/cover/${row.thumbnail}` : ""
            setFile(preview)
            setShow({ ...show, thumbnail: true })
        },

        /**
         * Handled remove position
         */
        handledRemove = (pid) => {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className='custom-ui'>
                            <h3><i className="fas fa-exclamation-circle"></i>&nbsp;Eliminar Vimeo</h3>
                            <p>¿Realmente deseas eliminar este vimeo?</p>
                            <div className="text-center">
                                <button className="btn btn-secondary" onClick={onClose} style={{ float: "left" }}><i className="fas fa-times"></i>&nbsp;Cancel</button>
                                <button className="btn btn-success" onClick={() => setRemove(pid, onClose)} style={{ float: "right" }}><i className="fas fa-check"></i>&nbsp;Aceptar</button>
                            </div>
                        </div>
                    )
                }
            });
        },

        /**
         * Validate the form
         * @returns true or false
         */
        handleValidate = (type = "add") => {
            setErrors({})
            if (!form.title) { setErrors({ title: true }); return false; }
            else if (!form.vimeoId && type !== "edit") { setErrors({ vimeoId: true }); return false; }
            return true;
        };

    const columns = [
        {
            name: 'Code', selector: row => row.code, minWidth: '10%', maxWidth: '10%', sortable: true, cell: row => (
                <span>{row.code}</span>
            )
        }, {
            name: 'Título', selector: row => row.title, minWidth: '57%', maxWidth: '57%', sortable: true, cell: row => (
                <span>{row.title}</span>
            )
        }, {
            name: 'Creado', selector: row => row.created, minWidth: '20%', maxWidth: '20%', sortable: true, cell: row => (
                <span>{moment(row.created).format("DD/MM/YYYY hh:mm A")}</span>
            )
        }, {
            name: '', minWidth: '13%', maxWidth: '13%', cell: row => (
                <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center", alignContent: "space-between" }}>
                    <TooltipButton style={{ margin: "0 auto" }} icon="fas fa-image" className="btn btn-secondary btn-sm pointer"
                        onClick={() => handledShowCover(row)} tooltip="Miniatura Vimeo" />

                    <TooltipButton style={{ margin: "0 auto" }} icon="fas fa-play" className="btn btn-secondary btn-sm pointer"
                        onClick={() => handledShowView(row.code)} tooltip="Ver Video" />

                    <TooltipButton style={{ margin: "0 auto" }} icon="fas fa-edit" className="btn btn-secondary btn-sm pointer"
                        onClick={() => handledShowEdit(row.vimeo_id)} tooltip="Editar Vimeo" />

                    <TooltipButton style={{ margin: "0 auto" }} icon="fas fa-trash-alt" className="btn btn-secondary btn-sm pointer"
                        onClick={() => handledRemove(row.vimeo_id)} tooltip="Eliminar Vimeo" />
                </div>
            )
        }
    ], paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    return (
        <Page columns={columns} paginationOptions={paginationOptions} show={show} setShow={setShow} 
            form={form} errors={errors} handledUpdateCover={handledUpdateCover} file={file} rows={rows}
            setForm={setForm} handledAdd={handledAdd} handledRemove={handledRemove} 
            handledUpdate={handledUpdate} video={video} setVideo={setVideo} />
    );
}

const mapStateToProps = ({ vimeo }) => ({
    vimeo
});

const mapDispatchToProps = () => ({
    ...VimeosActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps())(Vimeo));